import { all, fork } from 'redux-saga/effects';
import { notificationsSaga } from '../containers/Notifications/slice/saga';
import { portalSaga } from '../layouts/MainLayout/slice/saga';
import { loginSaga } from '../containers/login/slice/saga';
import { projectsSaga } from '../containers/projects/slice/saga';
import { languagesSaga } from '../containers/languages/slice/saga';
import { workspaceSaga } from '../containers/projectWorkspace/slice/saga';

// eslint-disable-next-line import/prefer-default-export
export function* rootSaga() {
  yield all([
    fork(notificationsSaga),
    fork(portalSaga),
    fork(loginSaga),
    fork(projectsSaga),
    fork(languagesSaga),
    fork(workspaceSaga),
  ]);
}
